module.exports = __webpack_public_path__ + "img/ic_peer_feedback.4c3a513d.png";